export enum WithdrawalStatus {
    Pending = 'CREATED',
    Completed = 'EXECUTED',
    Failed = 'CANCELED'
}